import { i18n } from 'i18n';
import { EBrokenLinksErrors } from 'shared/typings';

export const BROKEN_LINKS_ERRORS = () => ({
	[EBrokenLinksErrors.OFFER_INACTIVE]: i18n.t('Оффер неактивен'),
	[EBrokenLinksErrors.OFFER_NOT_FOUND]: i18n.t('Оффер не найден'),
	[EBrokenLinksErrors.PUBLISHER_INACTIVE]: i18n.t('Пользователь неактивен'),
	[EBrokenLinksErrors.REDIRECT_URL_NOT_FOUND]: i18n.t('URL-адрес для редиректа не найден'),
	[EBrokenLinksErrors.SOURCE_INACTIVE]: i18n.t('Площадка не активна'),
	[EBrokenLinksErrors.SOURCE_NOT_FOUND]: i18n.t('Площадка не найдена'),
	[EBrokenLinksErrors.SOURCE_OFFER_RELATION_INACTIVE]: i18n.t('Связь площадки и оффера не активна'),
});
